export default __webpack_public_path__ + "static/media/doctors.a2bfdf06.png";